import React from 'react'
import styled from 'styled-components'

import { palette, fonts, mediaQueries } from '../../styles/variables'
import { translate } from '../../utils/translation'
import paymentMethodIcon from '../../styles/assets/alerts/payment_method.svg'
import Icon from '../icon/Icon'
import { PrimaryButton } from '../buttons/Buttons'

import Modal, { ModalHeader, ModalContent, ModalFooter } from './Modal'

const PAYMENT_ERRORS = {
  BILLING_ERROR: {
    title: 'invalid_method_heading',
    description: 'invalid_method_subheading',
    button: {
      text: 'update_payment_method',
      onClick: (openUpdatePaymentMethodModal) => {
        openUpdatePaymentMethodModal()
      },
    },
  },
}

const Title = styled.span({
  color: palette.darkGray,
  fontSize: 20,
  lineHeight: '32px',
  fontWeight: 500,
  fontFamily: fonts.primaryMedium,
  textAlign: 'center',
  [mediaQueries.mobile]: {
    width: '100%',
    fontSize: '18px',
    marginLeft: 0,
    marginTop: 20,
    transform: 'translateX(0)',
  },
})

const Text = styled.span({
  display: 'block',
  color: palette.darkGray,
  fontFamily: fonts.primaryLight,
  fontSize: 14,
  textAlign: 'center',
  lineHeight: '25px',
  whiteSpace: 'pre-wrap',
  [mediaQueries.mobile]: {
    padding: '0 20px',
  },
})

const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
  },
})

const desktopStyle = {}

const mobileStyle = {
  width: '90%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
}

const PModalFooter = styled(ModalFooter)({
  background: palette.white,
  borderTop: `1px solid ${palette.lightGray50}`,
  [mediaQueries.mobile]: {
    flexDirection: 'column-reverse',
    justifyContent: 'center',
  },

  '& button': {
    [mediaQueries.mobile]: {
      marginTop: '15px',
    },
  },
})

const CloseButton = styled.div((props) => ({
  position: 'absolute',
  top: '10px',
  right: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  height: '24px',
  borderRadius: props.circled ? '12px' : 0,
  cursor: 'pointer',
  ':before': {
    content: `''`,
    borderLeft: `2px solid ${props.color || palette.pureBlack}`,
    height: props.size || '18px',
    transform: 'rotate(45deg)',
  },
  ':after': {
    content: `''`,
    borderLeft: `2px solid ${props.color || palette.pureBlack}`,
    height: props.size || '18px',
    transform: 'rotate(-45deg)',
    marginLeft: '-2px',
  },
  ...(props.styles || {}),
}))

export default (props) => {
  const {
    isOpen: { error },
    onClose,
    openUpdatePaymentMethodModal,
    ...rest
  } = props
  const config = PAYMENT_ERRORS?.[error]
  return (
    <Modal
      isOpen={!!config}
      desktopStyle={desktopStyle}
      mobileStyle={mobileStyle}
      overlayStyle={{ zIndex: 100000 }}
      {...rest}
    >
      <ModalHeader>
        <CloseButton onClick={onClose} />
        <Row>
          <Icon src={paymentMethodIcon} transform="translateX(-50%)" />
          <Title>{translate(config?.title)}</Title>
        </Row>
      </ModalHeader>
      <ModalContent style={{ height: 'calc(100% - 200px)' }}>
        <Text>{translate(config?.description)}</Text>
      </ModalContent>
      {config?.button && (
        <PModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
          <PrimaryButton
            theme="orange"
            onClick={() => {
              config?.button?.onClick(openUpdatePaymentMethodModal)
              onClose()
            }}
            tag={translate(config?.button?.text)}
          />
        </PModalFooter>
      )}
    </Modal>
  )
}
